import React from "react";

const AppsContent = (props: any) => {
  return (
    <div style={{marginTop:"100px", height: "calc(100vh - 100px)", width: "calc(100vw - 56px - 312px - 314px)" }}>
     AppsContent
    </div>
  );
};

export default AppsContent;
